<template>

  <v-flex md12="md12">
    <v-text-field v-model="d" label="Date" :placeholder="placeholder" :error="dateError" :messages="message"></v-text-field>
  </v-flex>

</template>

<script>

export default {
  name: 'TopActionDatePicker',
  props: ['value', 'item'],
  data () {
    return {
      d: '',
      message: ''
    }
  },
  computed: {
    placeholder () {
      switch (this.item.type) {
        default:
        case 'week':
          return 'dd/mm/yyyy'
        case 'month':
          return 'mm/yyyy'
        case 'year':
          return 'yyyy'
      }
    },

    reg () {
      switch (this.item.type) {
        default:
        case 'week':
          return /(\d\d?)\/(\d\d?)\/(\d{4})/
        case 'month':
          return /(\d\d?)\/(\d{4})/
        case 'year':
          return /(\d{4})/
      }
    },

    currentDate () {
      const date = this.reg.exec(this.d)

      if (date === null) {
        return null
      }

      let day = 1
      let month = 1
      let year = 2019

      let i = 1
      /* eslint-disable no-fallthrough */
      switch (this.item.type) {
        case 'week':
          day = date[i++]
        case 'month':
          month = date[i++]
        case 'year':
          year = date[i]
      }
      return {day, month, year}
    },

    dateError () {
      const d = this.currentDate

      if (d === null) {
        return true
      }

      // Basic day value check
      if (d.day < 1 || d.day > 31) {
        return true
      }

      // Check month value
      if (d.month < 1 || d.month > 12) {
        return true
      }

      const monthDays = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      // Check if Feb 30 on bisextil year
      if ((d.year % 4 === 0) && d.month === 2 && d.day === 30) {
        return false
      }

      // Check if day fit in month
      if (d.day > monthDays[d.month - 1]) {
        return true
      }
      return false
    }
  },
  methods: {
    update () {
      if (this.dateError || this.timeError) {
        console.log('Error:', this.dateError, this.timeError)
        return
      }
      console.log('Ok')
      const d = this.currentDate
      const date = new Date(Date.UTC(d.year, d.month - 1, d.day))
      const mon = this.monday(date)
      console.log(this.item.type, date.getTime(), mon.getTime())
      if (this.item.type === 'week' && date.getTime() !== mon.getTime()) {
        setTimeout(() => {
          this.message = `The date ${this.formatDate(mon)} will be used instead because it's a monday`
        }, 1)
        console.log(this.message)
      }

      this.$emit('input', date.toISOString())
    },

    refresh () {
      const date = new Date(this.value)
      this.refreshDate(date)
    },

    refreshDate (date) {
      this.message = ''
      if (this.d !== '') {
        return
      }
      return this.formatDate(date)
    },

    monday (originalDate) {
      const d = new Date(originalDate)
      let weekday = d.getUTCDay()
      let diff = d.getUTCDate() - weekday + (weekday === 0 ? -6 : 1) // adjust when day is sunday
      return new Date(d.setUTCDate(diff))
    },

    formatDate (date) {
      const day = date.getUTCDate().toString().padStart(2, '0')
      const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
      const year = date.getUTCFullYear()

      return `${day}/${month}/${year}`
    }
  },
  watch: {
    d () {
      this.update()
    },
    value () {
      if (this.value) {
        this.refresh()
      } else {
        this.d = ''
      }
    }
  },
  mounted () {
    if (this.value) {
      this.refresh()
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/TopActionDatePicker.vue